import { useNavigate } from 'react-router-dom'
import '../styles/Admin.css'

const AdminWelcome = () => {
  const navigate = useNavigate()

  return (
    <div className="admin-container" dir="rtl">
      <div className="admin-title">ברוך הבא לinvitly !</div>
      <div className="admin-text">
        כאן המסך המנהל של invitly, בו תוכל לנהל את כל ההזמנות והאירועים שלך.
      </div>
      <button onClick={() => navigate('/admin-login')} className="admin-button">
        המשך
      </button>
    </div>
  )
}

export default AdminWelcome
